export const BOOK_DEMO_PATH = '/book-demo';

export enum PageRoute {
  CONFIDENTIALITY = '/terms/confidentiality-notice',
  COOKIE = '/terms/cookie-policy',
  DPA = '/terms/data-processing-agreement',
  PRIVACY = '/terms/privacy-policy',
  TERMS = '/terms/terms-of-service',
  TERMS_BASE = '/terms',
}
